export default {"src":"/_next/static/media/foodAlley-logo-white.4240cbd2.svg","height":142,"width":550,"blurWidth":0,"blurHeight":0};